// removed by extract-text-webpack-plugin
module.exports = {"base":"PostbattleScreen_base--OffP3","tabsContent":"PostbattleScreen_tabsContent--7GtHp"};


//////////////////
// WEBPACK FOOTER
// ./containers/PostbattleScreen/PostbattleScreen.scss
// module id = 545
// module chunks = 11 14